import React, { Component } from 'react';
import TweenMax from "gsap/TweenMax";
import './css/main.css';
import Navigation from './Navigation';
import Home from './Home';
import Resume from './Resume';
import Portfolio from './Portfolio';
import Contact from './Contact';

//Primary class that controls much of the app's behavior 
class App extends Component {
  constructor(props) {
    super(props);

    this.sections = {
      home: Home,
      resume: Resume,
      portfolio: Portfolio,
      contact: Contact
    };

    // Functions for changing the section article on the page
    this.sectionFromPath = this.sectionFromPath.bind(this);
    this.sectionChangeArticle = this.sectionChangeArticle.bind(this);
    this.changeStateArticle = this.changeStateArticle.bind(this);

    //Functions for scrolling the content horizontally
    this.sectionChangeAside = this.sectionChangeAside.bind(this);
    this.flipScrollState = this.flipScrollState.bind(this);

    //Animated Transitions
    this.resetScroll = this.resetScroll.bind(this);
    this.transitionToPage = this.transitionToPage.bind(this);

    window.onpopstate = this.handleHistoryPop.bind(this);   // Some routing handling
    this.state = {section: this.props.startPath, isAside: false};
  }

  // Derives the correct section component to render from the path given
  sectionFromPath(path){
    const Section = this.sections[path];
    if (Section) {
      return <Section onSectionChange={this.sectionChangeArticle} onAsideSection={this.sectionChangeAside} />;
    } else {
      return (
        "Huh. We must have taken a wrong turn at Albequeque."
      );
    }
  }

  //Runs when the compontent is loaded onto the screen. Animates loaded state.
  componentDidMount(){
    TweenMax.from("#main", 1, {className:"bg-stripe-out"});
    TweenMax.from("#article", 1, {y:-50, autoAlpha: 0});
  }

  // Flips the horizontal scroll state of the app to the specified state
  flipScrollState(state){
    this.setState({isAside: state});
  }

  // Changes the article state of the page and pushes the new address into the address bar/history
  changeStateArticle(page){
    if (page === null || page === ""){
      page = "home";
    }
    this.setState({isAside: false, section: page});
  }

  // Fires on a link click requesting for an article, processes the event and changes the state of the article if need be
  sectionChangeArticle(page, e){
    e.preventDefault();
      if (page !== this.state.section){
        this.transitionToPage(page);
        window.history.pushState(page, page, "/" + page.toLowerCase()); // We've handled some routing here
      } else {
        if (this.state.isAside) {
          this.resetScroll();
        }
      }
  }

  // Fires on a link click requesting for an additional aside information in the same article, scrolls the page if nessassary
  sectionChangeAside(scroll, e){
    e.preventDefault();
    if (scroll !== this.state.isAside) {
      if (!scroll){
        this.resetScroll();
      } else {
        this.flipScrollState(scroll);
      }
    }
  }

  // Handles the back and forward button being pressed
  handleHistoryPop(e){
      this.transitionToPage(e.state);
  }

  // Animates a transition to the specified page, then calls the function that changes the article state to the specified page
  transitionToPage(page){
    TweenMax.to("#main", 0.4, {className:"bg-stripe-out"});
    TweenMax.to("#article", 0.4, {y:50, autoAlpha: 0, onComplete:this.changeStateArticle, onCompleteParams:[page]});
  }

  // Animations that scrolls the section right
  resetScroll(){
    TweenMax.to("#main", 1, {className:"bg-stripe"});
    TweenMax.to("#article-main", 1, {x: 0});
    TweenMax.to("#article-aside", 1, {x: 0, onComplete:this.flipScrollState, onCompleteParams:[false]});
  }

  // Function is called when this component gets updated
  // Handles transition outs 
  componentDidUpdate(prevState){
    if (prevState.section !== this.state.section){
      TweenMax.to("#main", 0.4, {className:"bg-stripe"});
      TweenMax.to("#article", 0.4, {y:0, autoAlpha: 1});
    }
    if (prevState.isAside !== this.state.isAside){
      if (this.state.isAside){
        let article = document.getElementById("article-main");
        TweenMax.to("#main", 1, {className:"bg-stripe-side"});
        TweenMax.to("#article-main", 1, {x: -1 * article.offsetWidth});
        TweenMax.to("#article-aside", 1, {x: -1 * article.offsetWidth});
        TweenMax.to(window, 1, {scrollTo:0});
      }
    }
  }

  // Renders the state to the screen
  render() {
    return (
      <div id="main-lining">
        <div id="heading">
          <img id="logo" src="img/main-logo.jpg" alt="Wei Kong Logo"/>
          <h1 id="head-name">Wei Kong</h1>
        </div>
        <div id="main-body" className="clearfix">
          <div id="site-nav">
            <Navigation currentSection={this.state.section} sections={this.sections} onSectionChange={this.sectionChangeArticle}/>
          </div>
          <div id="vr"></div>
          <div id="article">
            {this.sectionFromPath(this.state.section)}
          </div>
        </div>
        <div id="footer">
          Copyright Wei Kong 2018. All rights reserved.
        </div>
      </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js